module.exports = __webpack_public_path__ + "img/DK10519608.cbccc686.png";